import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import './RTModal.css';

const RTModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'medium', // small, medium, large, xlarge
  disableBackdropClick = false,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && onClose && !disableBackdropClick) {
      onClose();
    }
  };

  const modal = (
    <div className="rt-modal-overlay" onClick={handleOverlayClick}>
      <div className={`rt-modal ${size}`} role="dialog" aria-modal="true">
        <div className="rt-modal-header">
          <h3 className="rt-modal-title">{title}</h3>
          {onClose && (
            <button
              className="rt-modal-close"
              onClick={onClose}
              aria-label="Close modal"
              type="button"
            >
              <FaTimes />
            </button>
          )}
        </div>

        <div className="rt-modal-body">{children}</div>

        {footer && <div className="rt-modal-footer">{footer}</div>}
      </div>
    </div>
  );

  // Portal to body so overflow/stacking on page scroll + side menu cannot clip the modal
  return createPortal(modal, document.body);
};

export default RTModal;
